import React from "react";
import { useSelector } from "react-redux";
import { selectUserData } from "../../redux/state/authReduser/authentification.selectors";
import { Box, Card, CardContent, Typography, Divider, useTheme } from "@mui/material";

const OrderHistory = () => {
  const userData = useSelector(selectUserData);
  const theme = useTheme();

  if (!userData?.orderHistory?.length) {
    return (
      <Box sx={{ padding: "20px", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Typography variant="h6" sx={{ color: theme.palette.text.primary, fontFamily: 'Roboto, sans-serif' }}>
          История заказов пуста
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ padding: "20px", display: "flex", flexDirection: "column", gap: "20px" }}>
      {userData.orderHistory.map((order) => (
        <Card
          key={order._id}
          sx={{
            background: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.1)" : "rgba(0, 0, 0, 0.05)",
            borderRadius: "16px", // Округлые края
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
            transition: "0.3s",
            "&:hover": {
              boxShadow: "0 10px 20px rgba(0, 0, 0, 0.3)",
            },
            padding: "20px",
            fontFamily: 'Roboto, sans-serif',
          }}
        >
          <CardContent>
            <Typography variant="h6" sx={{ fontWeight: 600, color: theme.palette.text.primary, marginBottom: "10px" }}>
              {order.productName}
            </Typography>

            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: "8px" }}>
              <strong>Вес:</strong> {order.weight} кг
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: "8px" }}>
              <strong>Район:</strong> {order.district}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: "8px" }}>
              <strong>Оплата:</strong> {order.paymentMethod}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: "8px" }}>
              <strong>Кошелек:</strong> {order.wallet}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, marginBottom: "16px" }}>
              <strong>Дата создания:</strong> {new Date(order.createdAt).toLocaleString()}
            </Typography>

            {/* Статус "Не оплачено" с адаптивным цветом для светлой и тёмной темы */}
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                fontSize: "16px",
                color: theme.palette.mode === "dark" ? "red" : "darkred",
                marginTop: "10px",
              }}
            >
              Не оплачено
            </Typography>
          </CardContent>
          <Divider sx={{ margin: "12px 0" }} />
        </Card>
      ))}
    </Box>
  );
};

export default OrderHistory;
